import * as Styled from "./style";

type Props = {
  texts: string[];
};

/**
 * 受け取った複数のテキストを親要素の幅に応じて
 * 改行または一行にして表示する
 */
export const FlexibleInlineText = (props: Props) => {
  const { texts } = props;
  return (
    <span>
      {texts.map((text, idx) => {
        return <Styled.SpanSubText key={idx}>{text}</Styled.SpanSubText>;
      })}
    </span>
  );
};
